// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__aZkPx","author":"Table_author__2KCKB","authorImage":"Table_authorImage__2aUVq","unreadRow":"Table_unreadRow__2SwW7"};